import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, switchMap } from 'rxjs';
import {
  PhoneResponse,
  PukICCDPayload,
  PukICCDResponse
} from '../models/sim.model';
import { environment } from '../../../environments/environment';
import { UserService } from './user.service';
import { PublicTokenResponse } from '../models/auth.model';
import { UserState } from '../models/user.model';

@Injectable({
  providedIn: 'root',
})
export class SimService {
  physicalCardValidationURL = environment.physicalCardValidationService;
  simActivationURL = environment.simActivationService;
  phoneNumberURL = environment.phoneNumberService;

  constructor(
    private http: HttpClient,
    private userService: UserService,
  ) {}

  getPhoneNumber(iccid: string): Observable<PhoneResponse> {
  return this.userService.getAuthToken().pipe(
    switchMap((tokenResponse: PublicTokenResponse) => {
      return this.http.get<PhoneResponse>(
        `${this.phoneNumberURL}/${iccid}`,
        {
          headers: new HttpHeaders({
            'Content-Type': 'application/json',
            Authorization: `Bearer ${tokenResponse.data.token}`,
          }),
        }
      );
    }),
  );
}

  validatePhysicalSimcard(
    payload: PukICCDPayload,
  ): Observable<PukICCDResponse> {
    return this.userService.getAuthToken().pipe(
      switchMap((tokenResponse: PublicTokenResponse) => {
        return this.http.post<PukICCDResponse>(
          `${this.physicalCardValidationURL}`,
          payload,
          {
            headers: {
              'content-type': 'application/json',
              Authorization: `Bearer ${tokenResponse.data.token}`,
            },
          },
        );
      }),
    );
    /* return this.getPhoneNumber(payload.iccid).pipe(
      switchMap(data => {
        console.log(data);
        return this.http.post<PukICCDResponse>(`${this.physicalCardValidationURL}`,payload, {headers: {'content-type': 'application/json','Authorization':'58bc6c71-97e8-4f47-9fb6-3f89b2b0e1c0'}})
      })
    ) */
    return this.http.post<PukICCDResponse>(
      `${this.physicalCardValidationURL}`,
      payload,
      {
        headers: {
          'content-type': 'application/json',
          Authorization: '58bc6c71-97e8-4f47-9fb6-3f89b2b0e1c0',
        },
      },
    );
  }

  activateSimCard(payload: UserState) {
    return this.userService.getAuthToken().pipe(
      switchMap((tokenResponse: PublicTokenResponse) => {
        return this.http.post<PukICCDResponse>(
          `${this.simActivationURL}`,
          payload,
          {
            headers: {
              'content-type': 'application/json',
              Authorization: `Bearer ${tokenResponse.data.token}`,
            },
          },
        );
      }),
    );
  }
}
